import {Component, OnInit} from '@angular/core';
import {UserService} from '../../shared/services/user_service';

@Component({
  selector: 'notd-id-doc',
  templateUrl: './id-doc.component.html',
  styleUrls: ['./id-doc.component.scss']
})
export class IdDocComponent implements OnInit {
  identityDocUrl = this.userService.getIdentityDocPath();
  user: any;
  uploaderIdentityDoc;
  componentMessage = {value: undefined, css: ''};
  saving = false;
  error = false;

  constructor(private userService: UserService) { }

  ngOnInit() {

    this.userService.getProfile().then(
      user => {
        this.user = user;
      },
      err => {
        console.error('Error', err);
      }
    );
  }

  saveIdentityDoc() {
    this.saving = true;
    this.error = false;

    this.uploaderIdentityDoc.execute().then(
      resp => {
        this.saving = false;
        if (this.uploaderIdentityDoc.filePath) {
          delete this.uploaderIdentityDoc.filePath;
        }
        this.componentMessage.value = 'Document saved';
        this.componentMessage.css = '';
        this.user = resp;
      },
      err => {
        this.saving = false;
        this.error = true;
        this.componentMessage.value = 'Error: ' + (err.message) ? err.message : 'Something went wrong! Try again';
        this.componentMessage.css = 'error';
      }
    );
  }

  uploaderIdentityEvent(uploader: any) {
    this.uploaderIdentityDoc = uploader;
  }

  getIdentityDoc() {
    return document.location.assign(this.userService.getIdentityDocPath());
  }

  canSave() {
    return (this.uploaderIdentityDoc && this.uploaderIdentityDoc.filePath);
  }
}
